export function getLastDayOfMonth(year: number, month: number): number {
  // month: 1..12; Date(year, month, 0) -> last day of previous month => desired
  return new Date(year, month, 0).getDate();
}
